<template>
    <div>
         <p class="bigTitle"><span class="floor">*</span>系统管理>员工管理</p>
         <div class="body">
                <p>全部员工</p>
                <div class="card" v-for="(item,index) in list"  :key="index.id">
                   <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>姓名:张三</span>
                            <el-button style="float: right; padding: 3px 0" type="text">管理员</el-button>
                        </div>
                        <div v-for="(item,index) in user" :key="index" class="text item">
                            {{item.title+'：' + item.value }}
                        </div>
                        <p>编辑|删除</p>
                    </el-card>
                </div>
         </div>
    </div>
</template>

<script>
export default {
    data() {
      return {
        list:[
            {id:1,name:"1"},
            {id:2,name:"2"},
            {id:3,name:"3"},
            {id:4,name:"4"},
            {id:5,name:"5"}
        ],
        user:[
            {title:"账号",value:"joker"},
            {title:"部门",value:"财务部"},
            {title:"手机",value:"18040480198"},
            {title:"座机",value:"028-26736824"},
            {title:"邮箱",value:"547402844@qq.com"},
        ]
      }
    },
    methods: {
    
  }
  };
</script>

<style scoped>

.bigTitle{
    text-align: left;
}

.floor{
    width: 15px;
    background-color: #0F86DA;
    color:#0F86DA;
    border-radius: 5px;
}

.body{
    background-color: #FFFFFF;
    border-radius: 10px;
}
.card{
    width: 20%;
    /* background-color:beige; */
    width: 33%;
    float: left;
}

.text {
    font-size: 14px;
    text-align: left;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 480px;
  }

</style>


// WEBPACK FOOTER //
// src/components/Hotel/product/setup/userAdmin.vue